export const DEFAULT_ROUTE = '/dashboard';

export const ABNORMALITIES = {
    BLOWOUT: 'BLOWOUT',
    DAMAGE: 'DAMAGE',
    DELAY: 'DELAY',
    EARLY_FREIGHT: 'EARLY_FREIGHT',
    GENERIC: 'GENERIC',
    INTERNAL_LOGISTICS: 'INTERNAL_LOGISTICS',
    LATE_FREIGHT: 'LATE_FREIGHT',
    MISCOLLECTION: 'MISCOLLECTION',
    NEW_ORDER: 'NEW_ORDER',
    RETURN_FREIGHT: 'RETURN_FREIGHT',
    SHORT_SHIPMENT: 'SHORT_SHIPMENT',
    PARTIAL_SHORT_SHIPMENT: 'PARTIAL_SHORT_SHIPMENT',
    UNABLE_TO_LOCATE: 'UNABLE_TO_LOCATE',
};

export const SEVERITIES = {
    GREEN: 'GREEN',
    YELLOW: 'YELLOW',
    ORANGE: 'ORANGE',
    RED: 'RED',
};

export const GPS_INTERVALS = {
    ALL: 'ALL',
    SAMPLE_15: 'SAMPLE_15',
    SAMPLE_30: 'SAMPLE_30',
    SAMPLE_60: 'SAMPLE_60',
    LAST_KNOWN: 'LAST_KNOWN',
};

export const MANIFEST_BASED = 'MANIFEST_BASED';
export const RUN_BASED = 'RUN_BASED';

export const ROLE_ACTIONS = {
    CANCELLER: 'CANCELLER',
    CLOSER: 'CLOSER',
    CREATOR: 'CREATOR',
    EDITOR: 'EDITOR',
    EXECUTOR: 'EXECUTOR',
    VIEWER: 'VIEWER',
};

export const RECOVERY_ACTIONS = {
    INSERT_MANIFEST: 'INSERT_MANIFEST',
    PULL_FORWARD: 'PULL_FORWARD',
    SLIDE: 'SLIDE',
    SPECIAL: 'SPECIAL',
    TAP: 'TAP',
};

export const STATUSES = {
    ACTION_TAKEN: 'ACTION_TAKEN',
    ACTIONS_EXECUTED: 'ACTIONS_EXECUTED',
    ASSIGNED: 'ASSIGNED',
    CANCELLED: 'CANCELLED',
    ONGOING: 'ONGOING',
    CLOSED: 'CLOSED',
};

export const RUN_STATUSES = {
    ARRIVED: 'ARRIVED',
    ONGOING: 'ONGOING',
    PLANNED: 'PLANNED',
};

export const ABNORMALITY_STATUSES = {
    ACTION_TAKEN: 'ACTION_TAKEN',
    ACTIONS_EXECUTED: 'ACTIONS_EXECUTED',
    ASSIGNED: 'ASSIGNED',
    CANCELLED: 'CANCELLED',
    CLOSED: 'CLOSED',
};

export const EXCLUDE_PSS_SS_OPTION = {
    NONE: 'NONE',
    ALL: 'ALL',
    ONLYTPCE: 'ONLYTPCE',
};

export const I18N = {
    ABNORMALITIES: {
        BLOWOUT: 'Blow Out',
        DAMAGE: 'Damage',
        DELAY: 'Delay',
        EARLY_FREIGHT: 'Early Freight',
        GENERIC: 'Generic',
        INTERNAL_LOGISTICS: 'Internal Logistics',
        LATE_FREIGHT: 'Late Freight',
        MISCOLLECTION: 'Miscollection',
        NEW_ORDER: 'New Order',
        RETURN_FREIGHT: 'Return Freight',
        SHORT_SHIPMENT: 'Short Shipment',
        PARTIAL_SHORT_SHIPMENT: 'Partial Short Shipment',
        UNABLE_TO_LOCATE: 'Unable To Locate',
    },
    ABNORMALITY_LOCATION: {
        OTHER: 'Other - Specify in the comment box', // DO NOT CHANGE WITHOUT BACKEND APPROVAL!
    },
    ABNORMALITY_STATUS: {
        ACTION_TAKEN: 'Action was taken',
        ACTIONS_EXECUTED: 'Actions were executed',
        ASSIGNED: 'Assigned',
        CANCELLED: 'Cancelled',
        CLOSED: 'Closed',
    },
    EXCLUDE_PSS_SS: {
        NONE: 'None',
        ALL: 'All',
        ONLYTPCE: 'Only TPCE',
    },
    GPS_INTERVAL: {
        ALL: 'All GPS locations',
        SAMPLE_15: 'Every 15 mins',
        SAMPLE_30: 'Every 30 mins',
        SAMPLE_60: 'Every 60 mins',
        LAST_KNOWN: 'Only last known location',
    },
    LOGISTIC_POINT_TYPE: {
        emcCodes: 'EMCs',
        crossDockCodes: 'Cross docks',
        consolidationPointCodes: 'Consolidation points',
    },
    RECOVERY_ACTIONS: {
        INSERT_MANIFEST: 'INSERT MANIFEST',
        PULL_FORWARD: 'PULL FORWARD',
        SPECIAL: 'SPECIAL',
        SLIDE: 'SLIDE',
        TAP: 'TAP',
    },
    RECOVERY_ACTION_STATUS: {
        ASSIGNED: 'Assigned',
        CANCELLED: 'Cancelled',
        EXECUTED: 'Executed',
    },
    RFU_STATUS: {
        RFU_ALL: 'All manifests',
        RFU_ABNORMALITIES: 'All manifests with abnormalities',
        RFU_OPEN_ABNORMALITIES: 'All manifests with open abnormalities',
    },
    RUN_STATUS: {
        ARRIVED: 'Arrived',
        ONGOING: 'Ongoing',
        PLANNED: 'Planned',
    },
    SEVERITY: {
        RED: 'Red',
        ORANGE: 'Orange',
        YELLOW: 'Yellow',
        GREEN: 'Green',
    },
    STOP_TYPE: {
        BORDER: 'Border',
        BREAK_POINT: 'Break point',
        CONSOLIDATION_POINT: 'Consolidation point',
        CROSS_DOCK: 'Cross dock',
        EMC: 'EMC',
        SUPPLIER: 'Supplier',
        OTHER: 'Other',
    },
    FORMS: {
        SELECT_REASON: 'Select reason',
        SELECT_STOP: 'Select stop',
    },
    TLMS_UPDATE: {
        NO_VALIDATE: 'No validation needed',
        VALIDATE: 'Validation needed',
    },
    TRANSPORT_METHODS: {
        INSERT_MANIFEST: 'Insert Manifest',
        PLANNED_LOGISTICS: 'Planned Logistics',
        SPECIAL: 'Special',
    },
};

export const ROLES = {
    // Menu related rols
    ADMINISTRATION_MENU: 'ADMINISTRATION_MENU',
    DASHBOARD_MENU: 'DASHBOARD_MENU',
    MANIFEST_MENU: 'MANIFEST_MENU',
    REPORTS_MENU: 'REPORTS_MENU',
    RUN_MENU: 'RUN_MENU',

    // Dashboard related rols
    DASHBOARD_ABNORMALITY_VIEWER: 'DASHBOARD_ABNORMALITY_VIEWER',
    DASHBOARD_DELAY_VIEWER: 'DASHBOARD_DELAY_VIEWER',
    DASHBOARD_RECOVERY_ACTION_VIEWER: 'DASHBOARD_RECOVERY_ACTION_VIEWER',
    DASHBOARD_TRACKING_VIEWER: 'DASHBOARD_TRACKING_VIEWER',

    // Run related roles
    RUN_DETAILS_LP_EDITOR: 'RUN_DETAILS_LP_EDITOR',
    RUN_DETAILS_TME_EDITOR: 'RUN_DETAILS_TME_EDITOR',
    RUN_DETAILS_VIEWER: 'RUN_DETAILS_VIEWER',

    // Abnormality related roles

    // This enables a user to open the abnormality detail screen in a read-only mode
    ABNORMALITY_BLOWOUT_VIEWER: 'ABNORMALITY_BLOWOUT_VIEWER',
    ABNORMALITY_DELAY_VIEWER: 'ABNORMALITY_DELAY_VIEWER',
    ABNORMALITY_GENERIC_VIEWER: 'ABNORMALITY_GENERIC_VIEWER',
    ABNORMALITY_MISCOLLECTION_VIEWER: 'ABNORMALITY_MISCOLLECTION_VIEWER',

    // This enables a user to do the following actions on the corresponding abnormality:
    // Create abnormality
    // Update existing abnormality
    ABNORMALITY_BLOWOUT_CREATOR: 'ABNORMALITY_BLOWOUT_CREATOR',
    ABNORMALITY_DELAY_CREATOR: 'ABNORMALITY_DELAY_CREATOR',
    ABNORMALITY_GENERIC_CREATOR: 'ABNORMALITY_GENERIC_CREATOR',
    ABNORMALITY_MISCOLLECTION_CREATOR: 'ABNORMALITY_MISCOLLECTION_CREATOR',

    // This enables a user to do the following actions on the corresponding abnormality:
    // Mark abnormality as 'handled'
    ABNORMALITY_BLOWOUT_EDITOR: 'ABNORMALITY_BLOWOUT_EDITOR',
    ABNORMALITY_DELAY_EDITOR: 'ABNORMALITY_DELAY_EDITOR',
    ABNORMALITY_GENERIC_EDITOR: 'ABNORMALITY_GENERIC_EDITOR',
    ABNORMALITY_MISCOLLECTION_EDITOR: 'ABNORMALITY_MISCOLLECTION_EDITOR',

    // This enables a user to do the following actions on the corresponding abnormality:
    // Cancel abnormality
    ABNORMALITY_BLOWOUT_CANCELLER: 'ABNORMALITY_BLOWOUT_CANCELLER',
    ABNORMALITY_DELAY_CANCELLER: 'ABNORMALITY_DELAY_CANCELLER',
    ABNORMALITY_GENERIC_CANCELLER: 'ABNORMALITY_GENERIC_CANCELLER',
    ABNORMALITY_MISCOLLECTION_CANCELLER: 'ABNORMALITY_MISCOLLECTION_CANCELLER',

    // This enables a user to do the following actions on the corresponding abnormality:
    // Close abnormality
    ABNORMALITY_BLOWOUT_CLOSER: 'ABNORMALITY_BLOWOUT_CLOSER',
    ABNORMALITY_DELAY_CLOSER: 'ABNORMALITY_DELAY_CLOSER',
    ABNORMALITY_GENERIC_CLOSER: 'ABNORMALITY_GENERIC_CLOSER',
    ABNORMALITY_MISCOLLECTION_CLOSER: 'ABNORMALITY_MISCOLLECTION_CLOSER',

    // Recovery Actions related roles

    // This enables a user to open the recovery action detail screen in read-only mode
    RECOVERY_ACTION_EMA_VIEWER: 'RECOVERY_ACTION_EMA_VIEWER',
    RECOVERY_ACTION_INSERT_MANIFEST_VIEWER: 'RECOVERY_ACTION_INSERT_MANIFEST_VIEWER',
    RECOVERY_ACTION_PULL_FORWARD_VIEWER: 'RECOVERY_ACTION_PULL_FORWARD_VIEWER',
    RECOVERY_ACTION_SLIDE_VIEWER: 'RECOVERY_ACTION_SLIDE_VIEWER',
    RECOVERY_ACTION_SMA_VIEWER: 'RECOVERY_ACTION_SMA_VIEWER',
    RECOVERY_ACTION_SPECIAL_VIEWER: 'RECOVERY_ACTION_SPECIAL_VIEWER',
    RECOVERY_ACTION_TAP_VIEWER: 'RECOVERY_ACTION_TAP_VIEWER',

    // This enables a user to open the recovery action detail screen in read-only mode.
    // Beside that he can also mark the recovery action as executed.
    RECOVERY_ACTION_EMA_EXECUTOR: 'RECOVERY_ACTION_EMA_EXECUTOR',
    RECOVERY_ACTION_INSERT_MANIFEST_EXECUTOR: 'RECOVERY_ACTION_INSERT_MANIFEST_EXECUTOR',
    RECOVERY_ACTION_PULL_FORWARD_EXECUTOR: 'RECOVERY_ACTION_PULL_FORWARD_EXECUTOR',
    RECOVERY_ACTION_SLIDE_EXECUTOR: 'RECOVERY_ACTION_SLIDE_EXECUTOR',
    RECOVERY_ACTION_SMA_EXECUTOR: 'RECOVERY_ACTION_SMA_EXECUTOR',
    RECOVERY_ACTION_SPECIAL_EXECUTOR: 'RECOVERY_ACTION_SPECIAL_EXECUTOR',
    RECOVERY_ACTION_TAP_EXECUTOR: 'RECOVERY_ACTION_TAP_EXECUTOR',

    // This enables a user to do the following actions on the corresponding recovery action:
    // Create recovery action
    // Update existing recovery action
    RECOVERY_ACTION_EMA_EDITOR: 'RECOVERY_ACTION_EMA_EDITOR',
    RECOVERY_ACTION_INSERT_MANIFEST_EDITOR: 'RECOVERY_ACTION_INSERT_MANIFEST_EDITOR',
    RECOVERY_ACTION_PULL_FORWARD_EDITOR: 'RECOVERY_ACTION_PULL_FORWARD_EDITOR',
    RECOVERY_ACTION_SLIDE_EDITOR: 'RECOVERY_ACTION_SLIDE_EDITOR',
    RECOVERY_ACTION_SMA_EDITOR: 'RECOVERY_ACTION_SMA_EDITOR',
    RECOVERY_ACTION_SPECIAL_EDITOR: 'RECOVERY_ACTION_SPECIAL_EDITOR',
    RECOVERY_ACTION_TAP_EDITOR: 'RECOVERY_ACTION_TAP_EDITOR',

    // Manifest related roles
    MANIFEST_DETAIL_VIEWER: 'MANIFEST_DETAIL_VIEWER',

    //This enables user to view the ILOCS download navbar menu
    REPORTS_ILOCS_DATA_DOWNLOADER: 'REPORTS_ILOCS_DATA_DOWNLOADER',
};

export const TRANSPORT_METHODS = {
    INSERT_MANIFEST: 'INSERT_MANIFEST',
    PLANNED_LOGISTICS: 'PLANNED_LOGISTICS',
    SPECIAL: 'SPECIAL',
};
